import type { AxiosResponse } from "axios";

import config from "@/common/config";
import type { ApiResponse } from "@/types/api.type";

import ApiService from "./api.service";

export default {
  VERSION: config.api.versions.v2,

  enableSearchAssistance(): Promise<AxiosResponse<ApiResponse<null>>> {
    return ApiService.post("user/settings/exam/enable-search-assistance", {}, this.VERSION);
  },

  enableForeignDictionaries(): Promise<AxiosResponse<ApiResponse<null>>> {
    return ApiService.post("user/settings/exam/enable-foreign-dictionaries", {}, this.VERSION);
  }
};
